export default function (nga, admin) {
    var entity = admin.getEntity('licencetype')
        .label('Licence Type')
    //.readOnly();

    entity.listView()
        .fields([
            nga.field('id').isDetailLink(true),
            nga.field('name').isDetailLink(true),
            nga.field('code').label('CODE')
        ])
        .sortDir('asc')
        .url('licencetypes');

    entity.creationView().fields([
        nga.field('name'),
        nga.field('code', 'choice').label('CODE')
            .choices([
                {label: 'specialist', value: 'specialist'},
                {label: 'gold', value: 'gold'},
                {label: 'pro', value: 'pro'},
                {label: 'vr', value: 'vr'}
            ]),
    ]);

    entity.editionView().fields(entity.creationView().fields());
    entity.deletionView();

    return entity;
}


/** WEBPACK FOOTER **
 ** ./js/entities/licencetype/config.js
 **/